import MaterialsTypesEditView from "./materials_types-edit.html";


angular.module("materials_types")

    .controller("MaterialsTypesListCtrl", ['$state','treeService', '$q','LoginService', '$rootScope', '$scope', '$http', '$interval', 'i18nService', 'Restangular', 'gridService', 'modalService', '$uibModal', '$filter', '$translate',
        function ($state, treeService, $q, LoginService, $rootScope, $scope, $http, $interval, i18nService, Restangular, gridService, modalService, $uibModal, $filter, $translate) {
            //Comprobamos si tiene permiso escritura
            $scope.allowWrite = LoginService.permissionExist("MATERIAL_TYPES_WRITE");

        $rootScope.title = $filter('translate')('materials_types.title');
        $rootScope.breadcrumb = [
            { title: $filter('translate')('materials_types.title') }
        ];

        $scope.gridOptionsMaterialsTypes = {
            pdfTitle: $filter('translate')('materials_types.pdf_title'),
            exporterMenuCsv: true,
            enableGridMenu: true,
            expandAllRows: true,
            gridMenuShowHideColumns: false,
            enableSorting: true,            
            paginationPageSizes: [60, 80, 100],
            paginationPageSize: 60,
            onRegisterApi: function (gridApi) {
                this.gridApi = gridApi;
            },
            columnDefs: [
              { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
              { name: 'name', displayName: $filter('translate')('materials_types.name'), enableFiltering: true, enableHiding: false },
              {
                  name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                      { title: $filter('translate')('materials_types.button_edit'), action: 'ng-click="grid.appScope.addTypeMaterial(row.entity.id,row.entity.is_group);" ng-if="grid.appScope.allowWrite && row.entity.id != null"', cssIconClass: "fa fa-edit" },
                      { title: $filter('translate')('materials_types.button_delete'), action: 'ng-click="grid.appScope.deleteDialog(row.entity.id,row.entity.name);" ng-if="grid.appScope.allowWrite && row.entity.id != null"', cssIconClass: "fa fa-remove" }
                  ], { cssClass: "pull-right" })
              },
            ],
            getData: function (options) {             
                var deferred = $q.defer();

                Restangular.all('MaterialsTypes').getList(options).then(function (result) {
                    
                    result.unshift({
                        id: null,
                        name: $filter('translate')('events.tasks.without_group'),
                        material_type_id: null,
                        is_group: true
                    });
                    var treeMaterialsTypes = [];
                    var data = treeService.typesMaterialsTree(result, null, treeMaterialsTypes);
                   
                    deferred.resolve(data);
                });
                return deferred.promise;
            }
        };


        $scope.deleteDialog = function (id, name) {
            $scope.id = id;
            $scope.name = name;
            modalService.confirm({
                title: $filter('translate')('materials_types.button_delete'),
                message: $filter('translate')('materials_types.delete_message') + " " + $scope.name + "?",
                onAccept: function () {
                    Restangular.one('MaterialsTypes', $scope.id).remove().then(function () {
                        toastr.success($filter('translate')('materials_types.deleted_success'));
                        $scope.gridOptionsMaterialsTypes.gridApi.core.raise.itemDeleted($scope);
                    }, function (response) {
                        $scope.errorMessage = response.message;
                    });
                }
            });

        };

        $scope.addTypeMaterial = function (id, is_group) {
            let $modalInstance = $uibModal.open({
                animation: true,
                template: MaterialsTypesEditView,
                controller: "MaterialsTypesEditCtrl",
                size: 'lg',
                resolve: {
                    id: function () {
                        return id;
                    },
                    is_group: function () {
                        return is_group;
                    }
                }

            });

            //Retorno de los datos desde el modal.
            $modalInstance.result.then(function (resultModal) {

                if ($state.current.name == 'materials.edit') {
                    $rootScope.$emit("ReloadDataSelectTypeMaterials", {}); //LLamamos para que recarge los datos del combo.
                } else {
                    $scope.gridOptionsMaterialsTypes.loadData();
                }
                
            }, function () {
                console.info('Modal dismissed at: ' + new Date());
                //  $scope.identity = {};
            });
        }
        
    }])

;